import React from 'react';
import CustomCalendar from './CustomCalendar';
import './Calendar.css';

const Calendar = () => {
    return (
        <div className="calendar-tab">
            <div className="calendar-header">
                <h2>Family Calendar</h2>
                <p>View all family activities, weekend duties, and appointments</p>
            </div>

            <div className="calendar-content">
                <CustomCalendar />
            </div>
        </div>
    );
};

export default Calendar;
